export const XinFin = "https://erpc.xinfin.network";

export const RPC = {
  // Mainnet RPCs
  50: "https://erpc.xinfin.network",
  1: "http://45.136.18.107:8546",
  101: "https://api.mainnet-beta.solana.com",
  144: "wss://s1.ripple.com",
  0: "https://blockstream.info/api/",

  // Testnet RPCs
  51: "https://erpc.apothem.network",
  11155111: "https://rpc.sepolia.org", // Sepolia testnet
  103: "https://api.testnet.solana.com", // Solana testnet
  142: "wss://s.altnet.rippletest.net:51233", // XRP testnet
  3: "https://blockstream.info/testnet/api/", // Bitcoin testnet
};

export const BlockchainType = {
  // Mainnet
  50: "xinfin",
  1: "ethereum",
  101: "solana",
  144: "xrp",
  0: "bitcoin",

  // Testnet
  51: "xinfin",
  11155111: "ethereum",
  103: "solana",
  142: "xrp",
  3: "bitcoin",
};

export const ExplorerTx = {
  // Mainnet explorers
  50: "https://xdcscan.com/tx/",
  1: "https://etherscan.io/tx/",
  101: "https://solscan.io/tx/",
  144: "https://xrpscan.com/tx/",
  0: "https://blockstream.info/tx/",

  // Testnet explorers
  51: "https://explorer.apothem.network/tx/",
  11155111: "https://sepolia.etherscan.io/tx/", // Sepolia
  103: "https://solscan.io/tx/", // Solana testnet (same explorer)
  142: "https://testnet.xrpl.org/transactions/", // XRP testnet
  3: "https://blockstream.info/testnet/tx/", // Bitcoin testnet
};

// Helper function to check if chainId is testnet
export const IsTestnet = (chainId) => {
  const testnetChainIds = [51, 11155111, 103, 142, 3];
  return testnetChainIds.includes(parseInt(chainId));
};

// Helper function to check if chainId is mainnet
export const IsMainnet = (chainId) => {
  const mainnetChainIds = [50, 1, 101, 144, 0];
  return mainnetChainIds.includes(parseInt(chainId));
};
